import React from 'react';

import { Typography } from '@mui/material';

import { AttacksByProvince } from '../../@types/KingdomNews';

interface ProvAttacksProps {
  province: AttacksByProvince;
}

const ProvAttacks: React.FC<ProvAttacksProps> = ({ province }) => {
  return (
    <Typography key={province.provinceName} variant='body2' component='div'>
      <span
        style={{
          color: province.acresChanged > 0 ? 'Limegreen' : 'Red',
        }}
      >
        {province.acresChanged}
      </span>{' '}
      | {province.provinceName}{' '}
      <span
        style={{
          color:
            province.attacksMade > province.attacksSuffered
              ? 'Limegreen'
              : 'Red',
        }}
      >
        ({province.attacksMade}/{province.attacksSuffered})
      </span>
    </Typography>
  );
};

export default ProvAttacks;
